var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{staticClass:"switch",attrs:{"value":_vm.value,"input-value":_vm.inputValue,"label":_vm.label,"hint":_vm.hint,"name":_vm.name,"readonly":_vm.readonly,"persistent-hint":"","disabled":_vm.disabled},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }